<template>
    <div class="wrap">
        <listHeader
            :title="postData.lmid > 0 ? '编辑模块' : '新增模块'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="lmodule"
                active="info"
                :lmid="postData.lmid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="模块名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入模块名称" v-decorator="['lmname', {rules: [{ required: true, max: 64, message: '请输入模块名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="排序"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入排序值，整数、顺序排列" v-decorator="['ordernum', {rules: [{ required: true, message: '请输入排序值，整数、顺序排列' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'lmoduleCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'lid': '',
                'lmid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/lmodule/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.lmid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            lmname: res.data.lmname,
                            ordernum: res.data.ordernum,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.lmid > 0) {
                            url = '/manage/lmodule/edit';
                            values.lmid = this.postData.lmid;
                        } else {
                            url = '/manage/lmodule/save';
                            values.lid = this.postData.lid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.lmid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
